import template from './custom-information.html';
import { customInformationByRouteParam } from './custom-information.selectors';
import { actions, selectors } from '../../../state';
import './custom-information.global.css';
import { trackEngagement } from '@mover-app/engagement';
import { ITEM_DEFINITION_CODES } from '../../../constants';

class CustomInformationController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, dispatch } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Call page manually since we need info from the store and so it fires after
    // $stateChangeSuccess - analytics page has been ignored on state config object
    dispatch(
      actions.analytics.page(this.analyticsPageEvent, this.analyticsPageProps)
    );
    setTimeout(() =>
      trackEngagement({
        variant: this.analyticsPageProps && this.analyticsPageProps.code,
        code: ITEM_DEFINITION_CODES.INFORMATION,
        name: 'Custom Step',
      })
    );
  }

  $onDestroy() {
    this.disconnect();
  }
}

export const CustomInformationComponent = {
  template,
  controller: CustomInformationController,
};

function mapStateToThis(state) {
  const code = selectors.router.currentParamsCode(state);
  const itemDefinition = customInformationByRouteParam(code);
  const page = itemDefinition.page(state) || {};

  return {
    header: page.header,
    subheader: page.subheader,
    sections: page.sections,
    analyticsPageEvent: `Custom Step: ${page.breadcrumb_title}`,
    analyticsPageProps: {
      code,
      description: itemDefinition.shortDescription(state),
    },
  };
}
